import React from 'react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';
import FullWidthHeader from '../common/headers/FullWidthHeader';
import RecentCompaniesCard from './RecentCompaniesCard';
import RecentProcessesCard from './RecentProcessesCard';
import { bodyContentContainer } from '../../app/common/styles/CommonStyleObjects';
import OverdueMilestonesCard from './OverdueMilestonesCard';
import ComingDueMilestonesCard from './ComingDueMilestonesCard';
import OpenProcessesCard from './OpenProcessesCard';
import CanAccess from '../common/canAccess/CanAccess';

const DashboardPage: React.FunctionComponent = (): JSX.Element => {
  const renderHeader = (): JSX.Element => <h1>Home</h1>;
  return (
    <>
      <FullWidthHeader title={renderHeader} />

      <div className={`${bodyContentContainer} `}>
        <Stack horizontal wrap tokens={{ childrenGap: 30 }}>
          <CanAccess requestedAction="ProcessesList:View">
            <OverdueMilestonesCard />
          </CanAccess>
          <CanAccess requestedAction="ProcessesList:View">
            <ComingDueMilestonesCard />
          </CanAccess>
          <CanAccess requestedAction="ProcessesList:View">
            <OpenProcessesCard />
          </CanAccess>
          <RecentCompaniesCard />
          <CanAccess requestedAction="ProcessesList:View">
            <RecentProcessesCard />
          </CanAccess>
        </Stack>
      </div>
    </>
  );
};

export default DashboardPage;
